export const skills: string[] = [
  'React',
  'TypeScript',
  'JavaScript',
  'Redux',
  'Material UI',
  'Module Federation',
  'AWS',
  'Python',
  'CDK',
  'Terraform',
  'Java',
  'C',
  'Shell',
  'Networking',
  'Cisco IOS',
  'Windows',
  'Linux',
];
